/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Heart, MessageCircle, Send, Bookmark, ThumbsUp, Share2, PlusCircle } from 'lucide-react';

// PreviewFooter Component — intentionally mimics real social platform chrome (light UI)
const PostPreviewFooter = ({ layout, platform, caption, isMobile }) => {
  const [captionExpanded, setCaptionExpanded] = useState(false);

  if (layout === 'story') {
    return (
      <div className='flex-shrink-0 w-full px-2 py-2 md:px-3 md:py-3'>
        <div className='flex items-center gap-2 w-full'>
          {platform === 'facebook' && (
            <>
              <div className='w-6 h-6 md:w-9 md:h-9 flex-shrink-0 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full border border-white/40'>
                <PlusCircle className='w-4 h-4 md:w-5 md:h-5 text-white' />
              </div>
              <input
                type='text'
                placeholder='Send message'
                className='flex-1 min-w-0 bg-white/20 backdrop-blur-sm border border-white/40 rounded-full px-2 py-1 md:px-3 md:py-1.5 text-white text-xs md:text-sm placeholder-white/80 focus:ring-0 focus:outline-none cursor-not-allowed'
                readOnly
              />
              <div className='w-6 h-6 md:w-9 md:h-9 flex-shrink-0 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full border border-white/40'>
                <ThumbsUp className='w-4 h-4 md:w-5 md:h-5 text-white' />
              </div>
              {!isMobile && (
                <div className='w-6 h-6 md:w-9 md:h-9 flex-shrink-0 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full border border-white/40'>
                  <Heart className='w-4 h-4 md:w-5 md:h-5 text-white' />
                </div>
              )}
            </>
          )}
          {platform === 'instagram' && (
            <>
              <input
                type='text'
                placeholder='Send message'
                className='flex-1 min-w-0 bg-transparent border border-white/50 rounded-full px-2 py-1 md:px-3 md:py-1.5 text-white text-xs md:text-sm placeholder-white/70 focus:ring-0 focus:outline-none cursor-not-allowed'
                readOnly
              />
              <Heart className='w-4 h-4 md:w-6 md:h-6 text-white' />
              <Send className='w-4 h-4 md:w-6 md:h-6 text-white' />
            </>
          )}
        </div>
      </div>
    );
  }

  // Instagram feed footer
  if (platform === 'instagram') {
    return (
      <div className='p-2 md:p-3 flex-shrink-0'>
        <div className='flex items-center justify-between mb-2'>
          <div className='flex items-center gap-3'>
            <Heart className='w-3 h-3 md:w-6 md:h-6 cursor-pointer' style={{ color: '#262626' }} />
            <MessageCircle className='w-3 h-3 md:w-6 md:h-6 cursor-pointer' style={{ color: '#262626' }} />
            <Send className='w-3 h-3 md:w-6 md:h-6 cursor-pointer' style={{ color: '#262626' }} />
          </div>
          <Bookmark className='w-3 h-3 md:w-6 md:h-6 cursor-pointer' style={{ color: '#262626' }} />
        </div>
        <div className='text-[7px] md:text-sm font-semibold' style={{ color: '#262626' }}>
          89 likes
        </div>
        {caption && (
          <div className='text-[10px] md:text-sm' style={{ color: '#262626' }}>
            <span className={captionExpanded ? '' : 'line-clamp-2'}>{caption}</span>
            <button
              type='button'
              onClick={() => setCaptionExpanded(!captionExpanded)}
              className='ml-1 cursor-pointer'
              style={{ color: '#8e8e8e', fontSize: 'inherit' }}
            >
              {captionExpanded ? 'See less' : 'See more'}
            </button>
          </div>
        )}
      </div>
    );
  }

  // Facebook feed footer
  return (
    <>
      {caption && (
        <div
          className='px-2 md:px-3 py-1 md:py-2 flex-shrink-0'
          style={{ borderBottom: '1px solid #e4e6eb', color: '#050505' }}
        >
          <div className='text-[7px] md:text-sm'>
            <span className={captionExpanded ? '' : 'line-clamp-2'}>{caption}</span>
            <button
              type='button'
              onClick={() => setCaptionExpanded(!captionExpanded)}
              className='ml-1 cursor-pointer'
              style={{ color: '#65676b', fontSize: 'inherit' }}
            >
              {captionExpanded ? 'See less' : 'See more'}
            </button>
          </div>
        </div>
      )}

      <div
        className='px-2 md:px-3 py-2 flex items-center justify-between text-xs md:text-sm flex-shrink-0'
        style={{ borderBottom: '1px solid #e4e6eb', color: '#65676b' }}
      >
        <div className='flex items-center gap-1'>
          <div className='flex items-center -space-x-1'>
            <div className='w-3 h-3 md:w-5 md:h-5 rounded-full bg-blue-600 flex items-center justify-center border border-white'>
              <ThumbsUp className='w-2 h-2 md:w-3 md:h-3 text-white' fill='currentColor' />
            </div>
            <div className='w-3 h-3 md:w-5 md:h-5 rounded-full bg-red-500 flex items-center justify-center border border-white'>
              <Heart className='w-2 h-2 md:w-3 md:h-3 text-white' fill='currentColor' />
            </div>
          </div>
          <span className='ml-1 text-[7px] md:text-xs'>124</span>
        </div>
        <div className='flex gap-3 text-[7px] md:text-xs'>
          <span>5 Comments</span>
          <span>35 Shares</span>
        </div>
      </div>

      <div
        className='flex items-center justify-around p-2 text-xs font-semibold flex-shrink-0'
        style={{ color: '#65676b' }}
      >
        <span className='inline-flex items-center gap-1 px-2 py-1 rounded transition-colors cursor-pointer hover:bg-gray-100'>
          <ThumbsUp className='w-3 h-3 md:w-5 md:h-5' />
          <span className='hidden md:inline'>Like</span>
        </span>
        <span className='inline-flex items-center gap-1 px-2 py-1 rounded transition-colors cursor-pointer hover:bg-gray-100'>
          <MessageCircle className='w-3 h-3 md:w-5 md:h-5' />
          <span className='hidden md:inline'>Comment</span>
        </span>
        <span className='inline-flex items-center gap-1 px-2 py-1 rounded transition-colors cursor-pointer hover:bg-gray-100'>
          <Share2 className='w-3 h-3 md:w-5 md:h-5' />
          <span className='hidden md:inline'>Share</span>
        </span>
      </div>
    </>
  );
};

export default PostPreviewFooter;
